// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/Background/background (1).webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product_main_section__8C67\\+ {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  height: 70vh;
  max-width: 100%;
  margin: 0;
  padding: 0;

  .product_hero_section__sXDiB {
    margin: 3rem auto;
  }
}


/* --------media-queries---------- */

@media screen and (max-width: 568px) {
  br {
    display: none;
  }

  .product_main_section__8C67\\+{
    height: auto;
  }

  .product_hero_section__sXDiB{
    margin: 1rem 0;
  }

}
`, "",{"version":3,"sources":["webpack://./src/Pages/Product/product.module.css"],"names":[],"mappings":"AAAA;EACE,yDAAyE;EACzE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,UAAU;;EAEV;IACE,iBAAiB;EACnB;AACF;;;AAGA,oCAAoC;;AAEpC;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;AAEF","sourcesContent":[".main_section {\n  background-image: url(\"/public/images/Background/background\\ \\(1\\).webp\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 70vh;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n\n  .hero_section {\n    margin: 3rem auto;\n  }\n}\n\n\n/* --------media-queries---------- */\n\n@media screen and (max-width: 568px) {\n  br {\n    display: none;\n  }\n\n  .main_section{\n    height: auto;\n  }\n\n  .hero_section{\n    margin: 1rem 0;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_section": `product_main_section__8C67+`,
	"hero_section": `product_hero_section__sXDiB`
};
export default ___CSS_LOADER_EXPORT___;
